import { ActionReducer, MetaReducer } from "@ngrx/store";
import { resetStore } from "./actions"; // Ajusta la ruta
import { resetAppState } from "../../app.state";

// Meta-reducer para limpiar el store
export function clearStore(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    if (action.type === resetStore.type) {
      return resetAppState; // Esto restablece el estado a su valor inicial
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [clearStore];
